import React from "react";
import animations from "../util/animations";
import format from "../util/format";
import Reserved from "../components/Reserved";

export default class extends React.Component {
  state = {
    x: undefined
  };
  noop = () => null;

  static defaultProps = {
    animated: true,
    x: null,
    f: x => x,
    complex: false,
    nextPoint: () => (Math.random() - 0.5) * 2 * 1.1
  };

  componentDidMount() {
    if (this.props.animated) {
      animations.add(this.noop, {
        repeat: true,
        length: 1000,
        onEnd: () => {
          this.setState({ x: this.props.nextPoint() });
        }
      });
    }
  }

  componentWillUnmount() {
    animations.remove(this.noop);
  }

  format(x) {
    if (this.props.complex) {
      return format(...x);
    } else {
      return <Reserved value={x.toFixed(2)} reserve={"-8.88"} />;
    }
  }

  render() {
    const { animated } = this.props;
    let x = animated ? this.state.x : this.props.x;
    x = x || this.props.nextPoint();
    return (
      <span>
        <span
          style={{
            display: "inline-block",
            width: "60%",
            marginLeft: "-50%",
            textAlign: "right"
          }}
        >
          f({this.format(x)})
        </span>
        <span> = </span>
        <span
          style={{
            display: "inline-block",
            width: "60%",
            marginRight: "-50%",
            textAlign: "left"
          }}
        >
          {this.format(this.props.f(x))}
        </span>
      </span>
    );
  }
}
